/* eslint-disable no-undef */

import api from '@/api'
import Vue from 'vue'
import moment from 'moment'

export const GET_RECORDS = 'GET_RECORDS'
export const GET_RECHARGEORDER = 'GET_RECHARGEORDER'
export const GET_CONSUME_ORDERS = 'GET_CONSUME_ORDERS'
export const GET_RECHARGE_ORDERS = 'GET_RECHARGE_ORDERS'
export const SET_CONSUME_LOCK = 'SET_CONSUME_LOCK'
export const SET_RECHARGE_LOCK = 'SET_RECHARGE_LOCK'
export const SET_MONTHLY_REFRESH_LOCK = 'SET_MONTHLY_REFRESH_LOCK'
export const REFRESH_MONTHLY_ORDERS = 'REFRESH_MONTHLY_ORDERS'
export const GET_MONTHLY_ORDERS = 'GET_MONTHLY_ORDERS'

const finished = 'finished'
const unfinished = 'unfinished'
const all = 'all'
export default {
  state: {
    finishedOrders: [],
    unfinishedOrders: [],
    rechargeNoOrder: [],
    allOrders: [],
    consumeOrders: [],
    rechargeOrders: [],
    monthDivideOrders: [],
    monthOrdersRefreshFlag: false,
    consumeLock: false,
    rechargeLock: false
  },
  mutations: {
    [GET_RECORDS](state, data) {
      if (data.param === undefined) {
        return
      }
      if (data.param.payStr === finished) {
        if (data.param.page === 1) {
          Vue.set(state, 'finishedOrders', data.data ? data.data.orderList : [])
        } else {
          let oldOrders = JSON.parse(JSON.stringify(state.finishedOrders))
          Array.prototype.push.apply(oldOrders, data.data ? data.data.orderList : [])
          Vue.set(state, 'finishedOrders', oldOrders)
        }
      } else if (data.param.payStr === unfinished) {
        if (data.param.page === 1) {
          Vue.set(state, 'unfinishedOrders', data.data ? data.data.orderList : [])
        } else {
          let oldOrders = JSON.parse(JSON.stringify(state.unfinishedOrders))
          Array.prototype.push.apply(oldOrders, data.data ? data.data.orderList : [])
          Vue.set(state, 'unfinishedOrders', oldOrders)
        }
      } else if (data.param.payStr === all) {
        if (data.param.page === 1) {
          Vue.set(state, 'allOrders', data.data ? data.data.orderList : [])
        } else {
          let oldOrders = JSON.parse(JSON.stringify(state.allOrders))
          Array.prototype.push.apply(oldOrders, data.data ? data.data.orderList : [])
          Vue.set(state, 'allOrders', oldOrders)
        }
      }
    },
    [GET_CONSUME_ORDERS](state, data) {
      if (!data.data) {
        Vue.set(state, 'consumeOrders', [])
        return
      }
      if (data.page === 1) {
        Vue.set(state, 'consumeOrders', data.data)
      } else {
        let newOrder = state.consumeOrders.concat(data.data)
        Vue.set(state, 'consumeOrders', newOrder)
      }
    },
    [GET_RECHARGE_ORDERS](state, data) {
      if (!data.data) {
        Vue.set(state, 'rechargeOrders', [])
        return
      }
      if (data.page === 1) {
        Vue.set(state, 'rechargeOrders', data.data)
      } else {
        let newOrder = state.rechargeOrders.concat(data.data)
        Vue.set(state, 'rechargeOrders', newOrder)
      }
    },
    [GET_RECHARGEORDER](state, data) {
      if (!data.data) {
        Vue.set(state, 'rechargeNoOrder', [])
        return
      }
      if (data.param.page === 1) {
        Vue.set(state, 'rechargeNoOrder', data.data)
      } else {
        let newOrder = state.rechargeNoOrder.concat(data.data)
        Vue.set(state, 'rechargeNoOrder', newOrder)
      }
    },
    [SET_CONSUME_LOCK](state, data) {
      Vue.set(state, 'consumeLock', data)
    },
    [SET_RECHARGE_LOCK](state, data) {
      Vue.set(state, 'rechargeLock', data)
    },
    [REFRESH_MONTHLY_ORDERS](state, data) {
      Vue.set(state, 'monthDivideOrders', data)
    },
    [SET_MONTHLY_REFRESH_LOCK](state, flagValue) {
      Vue.set(state, 'monthOrdersRefreshFlag', flagValue)
    }
  },
  actions: {
    [GET_RECORDS]({
      commit
    }, param) {
      return new Promise(function (resolve, reject) {
        api.findOrderByHandheldBankPageList(null, param).then((data) => {
          commit(GET_RECORDS, {
            data: data.data,
            param: param
          })
          resolve()
        }, (data) => {
          commit(GET_RECORDS, {
            finishedOrders: [],
            unfinishedOrders: [],
            allOrders: []
          })
          reject(data)
        })
      })
    },
    [GET_CONSUME_ORDERS]({
      commit,
      state
    }, param) {
      return new Promise(function (resolve, reject) {
        api.queryConsumeOrders(param.user, param.start, param.end).then((data) => {
          commit(GET_CONSUME_ORDERS, {
            data: data.orders ? data.orders : [],
            page: param.page
          })
          divideOrderDataToMonthly(state)
          resolve()
        }, (data) => {
          commit(GET_CONSUME_ORDERS, {
            consumeOrders: []
          })
          reject(data)
        })
      })
    },
    [GET_RECHARGEORDER]({
      commit
    }, param) {
      return new Promise(function (resolve, reject) {
        api.findUserRechargeNotReceivedList(param.user, param.param.page).then((data) => {
          commit(GET_RECHARGEORDER, {
            data: data.data.userRechargeList,
            param: param.param
          })
          resolve()
        }, (data) => {
          commit(GET_RECHARGEORDER, {
            rechargeNoOrder: []
          })
          reject(data)
        })
      })
    },
    [GET_RECHARGE_ORDERS]({
      commit,
      state
    }, param) {
      return new Promise(function (resolve, reject) {
        api.queryRecharges(param.user, param.start, param.end).then((data) => {
          commit(GET_RECHARGE_ORDERS, {
            data: data.userRecharges ? data.userRecharges : [],
            page: param.page
          })
          divideOrderDataToMonthly(state)
          resolve()
        }, (data) => {
          commit(GET_RECHARGE_ORDERS, {
            rechargeOrders: []
          })
          reject(data)
        })
      })
    },
    [SET_CONSUME_LOCK]({
      commit
    }) {
      commit(SET_CONSUME_LOCK, true)
      setTimeout(() => {
        commit(SET_CONSUME_LOCK, false)
      }, 1000 * 60)
    },
    [SET_RECHARGE_LOCK]({
      commit
    }) {
      commit(SET_RECHARGE_LOCK, true)
      setTimeout(() => {
        commit(SET_RECHARGE_LOCK, false)
      }, 1000 * 60)
    },
    [SET_MONTHLY_REFRESH_LOCK]({
      commit
    }) {
      commit(SET_MONTHLY_REFRESH_LOCK, true)
    },
    [REFRESH_MONTHLY_ORDERS]({
      commit,
      state
    }, param) {
      if (state.monthOrdersRefreshFlag === true) {
        commit(SET_MONTHLY_REFRESH_LOCK, false)
        api.queryConsumeOrders(param.user, param.start, param.end).then((data) => {
          commit(GET_CONSUME_ORDERS, {
            data: data.orders ? data.orders : [],
            page: param.page
          })
          commit(REFRESH_MONTHLY_ORDERS, divideOrderDataToMonthly(state))
        }, (data) => {
          commit(GET_CONSUME_ORDERS, {
            consumeOrders: []
          })
        })
        api.queryRecharges(param.user, param.start, param.end).then((data) => {
          commit(GET_RECHARGE_ORDERS, {
            data: data.userRecharges ? data.userRecharges : [],
            page: param.page
          })
          commit(REFRESH_MONTHLY_ORDERS, divideOrderDataToMonthly(state))
        }, (data) => {
          commit(GET_RECHARGE_ORDERS, {
            rechargeOrders: []
          })
        })
      }
    }
  }
}

function divideOrderDataToMonthly(state) {
  if (state.rechargeOrders.length === 0 && state.consumeOrders.length === 0) {
    return []
  }
  let earlyMonthMoment = moment(getEarliestTimeByAllOrders(state)).startOf('month')
  let latestMonthMoment = moment(getLatestTimeByAllOrders(state)).startOf('month')
  // 计算总月份差
  let monthRange = latestMonthMoment.diff(earlyMonthMoment, 'month')
  let result = []
  for (let i = 0; i <= monthRange; i++) {
    // 当前月份(根据 i 偏移量计算)最早最晚时间戳
    let monthBeginMom = moment(getEarliestTimeByAllOrders(state)).startOf('month').add(i, 'month')
    let monthEndMom = moment(getEarliestTimeByAllOrders(state)).add(i, 'month').endOf('month')
    let date = monthBeginMom.format('YYYY年MM月') // 当前月份显示的字符
    let monthBeginTime = Date.parse(monthBeginMom) // 当前月份开始时间戳
    let monthEndTime = Date.parse(monthEndMom) // 当前月份结束时间戳
    let recharges = state.rechargeOrders.filter(r => r.rechargeTime >= monthBeginTime && r.rechargeTime <= monthEndTime)
    let consumes = state.consumeOrders.filter(c => c.consumeDate >= monthBeginTime && c.consumeDate <= monthEndTime)
    result.push({
      date: date,
      begin: monthBeginTime,
      end: monthEndTime,
      recharges: recharges,
      consumes: consumes
    })
  }
  return result
}

function getLatestTimeByAllOrders(state) {
  if (state.consumeOrders.length === 0 && state.rechargeOrders.length === 0) {
    return 0
  }
  let latestTime = state.consumeOrders.reduce((acc, cur) => {
    return cur.consumeDate > acc ? cur.consumeDate : acc
  }, 0)
  latestTime = state.rechargeOrders.reduce((acc, cur) => {
    return cur.rechargeTime > acc ? cur.rechargeTime : acc
  }, latestTime)
  return latestTime
}

function getEarliestTimeByAllOrders(state) {
  if (state.consumeOrders.length === 0 && state.rechargeOrders.length === 0) {
    return 0
  }
  let earliestTime = state.consumeOrders.reduce((acc, cur) => {
    return cur.consumeDate < acc ? cur.consumeDate : acc
  }, 4449488461000)
  earliestTime = state.rechargeOrders.reduce((acc, cur) => {
    return cur.rechargeTime < acc ? cur.rechargeTime : acc
  }, earliestTime)
  return earliestTime
}



// WEBPACK FOOTER //
// ./src/store/modules/records.js